import {MdOutlineMoreHoriz} from "react-icons/md"
import styled from "styled-components"
import formatConverter from "../../../../helper/formatConverter"
import { formatShipmentDate, getShipmentRouteBounds, normalizeShipmentListItem } from "../../../../helper/shipment/safeShipmentListItem"
import { Link, useNavigate } from "react-router-dom"
import { useDispatch } from "react-redux"
import { useEffect } from "react"
import { setLoadItemData, setLoadItemSelect } from "../../../../features/loadList/loadListSlice"
import { useRef } from "react"
import moment from "moment/moment"
import yayinlamaSecenekleriOptions from "../../../../utils/yukOptions/yayinlamaSecenekleriOptions"
import arrow from "../../../../images/svg/load-arrow.svg"
import loadIcon from "../../../../images/svg/topPages/load.svg"
import unloadIcon from "../../../../images/svg/topPages/unload.svg"

const Container = styled.div`
    width: 100%;
    display: flex;
    flex-direction: column;
    margin-bottom: 30px;
    color: ${({theme}) => theme.mainTextColor};

    .content-container{
        width: 100%;
        display: flex;
        flex-direction: column;
        gap: 10px;
        border-radius: 10px;
        cursor: pointer;
        border: 2px solid ;
        border-color:  ${({ theme }) => theme.mainBorderColor};
        position: relative;
        padding-bottom: 10px;
        .content-item{
            font-size: 12px;
            font-weight: var(--font-weight-md);
            text-align: center;
        }
        .status{
            padding: 5px;
            background-color: var(--color-main);
            display: flex;
            align-items: flex-start;
            justify-content: flex-start;
            border-top-left-radius: 8px;
            border-bottom-right-radius: 8px;
            color: #fff;
            width: fit-content;
        }
        .main-container{
            display: grid;
            grid-template-columns: 1fr 1fr 1fr;
            align-items: center;
            gap: 5px;
            .left-side, .mid, .right-side{
                display: flex;
                flex-direction: column;
                gap: 5px;
            }
            .line-container{
                display: flex;
                align-items: center;
                
                .line{
                    width: 100%;
                    border-bottom: 1px solid black;
                    margin-top: 4px;
                }
            }
        }
        .others{
            display: grid;
            grid-template-columns: 1fr 1fr 1fr;
            align-items: center;
            gap: 5px;
            text-align: center;
            padding-block: 10px;
            .content-col{
                display: flex;
                flex-direction: column;
                gap: 5px;
            }
        }
    }

    .title{
        font-size: 14px !important;
        font-weight: var(--font-weight-lg) !important;
    }
    
`

const ItemMobileContainer = ({item: sourceItem, activeItemId, handleClick}) => {
    const item = normalizeShipmentListItem(sourceItem)
    const {firstRoutePoint, lastRoutePoint} = getShipmentRouteBounds(item.routePoints)
    const dispatch = useDispatch()
    const navigate = useNavigate()

    useEffect(() => {
        if(activeItemId === item.id){
            handleClick(item.id)
        }
    },[activeItemId])

  return (
    <Container onClick={() => {dispatch(setLoadItemData({...item, pageTitle: "Tamamlanan Detay"})); navigate("/sevkiyat-detay")}}>

       <div className="content-container">
            <div className="status">
                <div className="content-item">Tamamlandı</div>
            </div>

            <div className="main-container">
                <div className="left-side">
                    <div className="content-item"><img src={loadIcon} alt="" /></div>
                    <div className="content-item title">{firstRoutePoint.displayName}</div>
                    <div className="content-item">{item?.waitinLoad?.planningLoadDate}</div>
                    <div className="content-item">{item.routePoints.$values.filter(item => item.loadOrUnload === 0).length} Yükleme</div>
                </div>

                <div className="mid">
                    <div className="content-item">{item?.isParsiyel ? "Parça" : "Komple"}</div>
                        {item.LoadUnitId === 3 ? (
                            <div className="content-item">
                            Basar Tonaj{" "}
                            {item.waitinLoad?.loadBulk > 0 &&
                                ` - ${item.waitinLoad?.loadBulk} ${item.waitinLoad?.loadBulk > 0 && "m3"}`}
                            </div>
                        ) : (
                            <div className="content-item">
                            {item.waitinLoad?.loadQuantity} {item.waitinLoad?.loadUnit}{" "}
                            {item.waitinLoad?.loadBulk > 0 &&
                                ` - ${item.waitinLoad?.loadBulk} ${item.waitinLoad?.loadBulk > 0 && "m3"}`}
                            </div>
                        )}
                    <div className="line-container">
                        <div className="top"><img src={arrow} alt="" /></div>
                        <div className="line" />
                        <div className="top"><img src={arrow} alt="" /></div>
                    </div>
                    <div className="content-item">
                        {formatConverter(item.waitinLoad?.distance, 0)} Km
                    </div>
                    <div className="content-item">
                        {item?.waitinLoad?.truckQuantity} Adet {item?.waitinLoad?.truckType}
                    </div>
                </div>

                <div className="right-side">
                    <div className="content-item"><img src={unloadIcon} alt="" /></div>
                    <div className="content-item title">{lastRoutePoint.displayName}</div>
                    <div className="content-item">{item?.waitinLoad?.planningUnloadDate}</div>
                    <div className="content-item">{item.routePoints.$values.filter(item => item.loadOrUnload === 1).length} Boşaltma</div>
                </div>
            </div>

            <div className="others">
                <div className="content-col">
                    <div className="title">Diğer Bilgiler</div>
                    <div className="content-item">{item?.freight} TL (hedef fiyat)</div>
                    <div className="content-item">Yük Yayınlanıyor</div>
                    <div className="content-item">Tamamlanma Saati: {formatShipmentDate(lastRoutePoint.routePointEndDate, value => moment(value).format("DD.MM.YYYY HH:mm"))}</div>
                </div>
                <div className="content-col">
                </div>
                <div className="content-col">
                </div>
            </div>
       </div>


    </Container>
  )
}

export default ItemMobileContainer
